import { parseSafeHtml } from "../../utils/sanitizeHtml";
import { parseLegalHtml } from "../../utils/docContent";
import { usePageMeta } from "../../lib/usePageMeta";
import "./DocPage.scss";

const PrivacyPolicy = ({ i18n, privacy, privacyUrdu }) => {
  const isUrdu = i18n.languages[0] === "urdu";
  const raw = isUrdu ? privacyUrdu || privacy : privacy;
  const { lastUpdated, content } = parseLegalHtml(raw);

  usePageMeta({
    title: "PkPlots | Privacy policy",
    description: "Privacy policy PkPlots",
    canonical: "/privacy",
  });

  return (
    <>
      <div className={`doc-page ${isUrdu ? "doc-page--rtl" : ""}`}>
        <header className='doc-page__hero'>
          <div className='doc-page__hero-inner'>
            <h1 className='doc-page__title'>
              {isUrdu ? "رازداری کی پالیسی" : "Privacy Policy"}
            </h1>
            <p className='doc-page__subtitle'>
              {isUrdu
                ? "ہم آپ کی معلومات کو کیسے جمع، استعمال اور محفوظ کرتے ہیں۔"
                : "How we collect, use and protect your information."}
            </p>
            {lastUpdated && (
              <div className='doc-page__meta'>
                <i className='bx bx-time-five' aria-hidden='true'></i>
                <span>
                  {isUrdu ? "آخری اپ ڈیٹ: " : "Last updated: "}
                  {lastUpdated}
                </span>
              </div>
            )}
          </div>
        </header>

        <div className='doc-page__body'>
          <div className='doc-page__content'>{parseSafeHtml(content)}</div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
